export default __webpack_public_path__ + "/images/google_cloud_logo.png";